// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionTitle_wrapper__35kVz","text":"SectionTitle_text__v-VbM","text_title":"SectionTitle_text_title__Gxq1M"};